import { useNavigate } from '@tanstack/react-router';
import { CircleAlert, Menu } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useDashboardContext } from '@/stores/context/dashboard-layout-context';
import { useStore } from '@/stores';

import { Container } from '../../custom/container';
import Logo from '../shared/logo';

import UserProfile from './profile-layout';

const Header = () => {
  const navigate = useNavigate();
  const { toggleSidebar } = useDashboardContext();
  const userProfile = useStore((state) => state.profile);

  const show2FA = !userProfile?.is_login_otp_enabled;
  const showReview = !userProfile?.business.is_approved;
  const singleTooltip = (show2FA && !showReview) || (!show2FA && showReview);

  return (
    <div className="fixed z-10 w-full px-4">
      <div className="flex w-full flex-row bg-[#f2f2f8] px-6 pt-[26px]" />
      <div className="flex w-full flex-row items-center justify-between rounded-md bg-white px-6 shadow">
        <div
          className="flex items-center justify-center max-sm:p-3 md:hidden"
          onClick={toggleSidebar}
        >
          <Menu className="h-5 w-5" />
        </div>
        <div className="hidden md:block">
          <Logo />
        </div>
        <div className="flex items-center gap-3">
          <Container
            spacing={1}
            className={`my-2 flex flex-col gap-2 sm:my-0 sm:w-auto sm:flex-row ${
              singleTooltip ? 'justify-center sm:justify-start' : ''
            }`}
          >
            {show2FA && (
              <Tooltip>
                <TooltipTrigger
                  onClick={() => navigate({ to: '/profile' })}
                  className="flex cursor-pointer flex-row items-center justify-center gap-1 rounded-2xl border border-red-600 bg-red-100 px-3 py-1 text-red-600 transition-all duration-300 hover:bg-red-600 hover:text-white md:py-2"
                >
                  <CircleAlert className="hidden h-4 w-4 sm:block md:h-4 md:w-4" />
                  <span className="text-xs sm:text-xs md:text-xs">2FA not enabled</span>
                </TooltipTrigger>
                <TooltipContent>
                  <p>2FA is not enabled on your account. You can enable it on profile menu</p>
                </TooltipContent>
              </Tooltip>
            )}
            {showReview && (
              <Tooltip>
                <TooltipTrigger
                  onClick={() => navigate({ to: '/profile' })}
                  className="ml-2 flex cursor-pointer flex-row items-center justify-center gap-1 rounded-2xl border border-yellow-700 bg-yellow-100 px-3 py-1 text-yellow-700 transition-all duration-300 hover:bg-yellow-700 hover:text-white md:py-2"
                >
                  <span className="text-xs sm:text-xs md:text-xs">Account On Review</span>
                </TooltipTrigger>
                <TooltipContent>
                  <p>Your registration has been accepted. Our team will reach out to you soon</p>
                </TooltipContent>
              </Tooltip>
            )}
          </Container>
          <Container direction="row" className="items-center max-sm:p-3">
            <UserProfile />
          </Container>
        </div>
      </div>
    </div>
  );
};

export default Header;
